const configs = {
  classNames: {
    filter: 'recipe-filter',
  },
};

export default configs;
